import React from 'react';
import { motion } from 'framer-motion';
import { ScanFaceIcon, MessageSquareXIcon, TimerOffIcon, FlagIcon, ShieldOffIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
const items = [{
  title: 'Anatomía del Migajero',
  desc: 'Por qué disfruta verte sufrir por él.',
  icon: ScanFaceIcon
}, {
  title: 'Traductor de Mentiras',
  desc: "Qué significa su 'te extraño' realmente.",
  icon: MessageSquareXIcon
}, {
  title: 'Test de las 72 Horas',
  desc: 'La respuesta que necesitas para ser libre.',
  icon: TimerOffIcon
}, {
  title: 'Scripts de Retirada',
  desc: 'Las palabras exactas para irte con la frente en alto.',
  icon: FlagIcon
}, {
  title: 'Contacto Cero',
  desc: 'Cómo sobrevivir cuando la soledad te ataque.',
  icon: ShieldOffIcon
}];
export function WhatYouGet() {
  return <section className="py-16 md:py-24 px-5 bg-[#FAF5EE]" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-5xl text-[#5C1A2B] mb-12 text-center leading-tight" data-id="element-161">
          5 herramientas dentro
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-162">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-white p-6 border border-[#E0D5C1] hover:border-[#C86B5E] transition-colors duration-300 group" data-id="element-163">
              <div className="w-10 h-10 bg-[#F2EBE1] group-hover:bg-[#C86B5E]/10 rounded-full flex items-center justify-center mb-4 transition-colors duration-300" data-id="element-164">
                <item.icon className="w-5 h-5 text-[#5C1A2B] group-hover:text-[#C86B5E] transition-colors duration-300" data-id="element-165" />
              </div>
              <h3 className="font-serif text-lg font-semibold text-[#2D2D2D] mb-2" data-id="element-166">
                {item.title}
              </h3>
              <p className="text-sm text-[#4A4A4A] font-light leading-relaxed" data-id="element-167">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-168">
          <a href="https://serenopulse.com/cart/47935901401346:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block bg-[#5C1A2B] hover:bg-[#7a2238] text-white font-medium py-4 px-8 tracking-wider uppercase text-xs sm:text-sm transition-all duration-300" data-id="element-169">
            Lo quiero ahora — $89 MXN
          </a>
        </motion.div>
      </div>
    </section>;
}